import React, { Component } from "react";
import { Drawer } from "antd";
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/es';

dayjs.extend(relativeTime);

class BillsDrawer extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.handleCloseForm = this.handleCloseForm.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.open && this.props.open) {
            // this.setState({ text: "" });
            // if (this.formRef.current) {
            //     this.formRef.current.resetFields();
            // }
        }
    }

    handleCloseForm() {
        // this.setState({ text: "" }, () => {
        //     if (this.formRef.current) {
        //         this.formRef.current.resetFields();
        //     }
        // });
        this.props.onClose();
    }

    render() {
        const { open } = this.props;

        return (
            <Drawer
                title="Facturas"
                placement="bottom"
                onClose={this.handleCloseForm}
                open={open}
                destroyOnClose
                style={{ paddingLeft: 250 }}
            // afterVisibleChange={(visible) => {
            //     if (!visible) {
            //         // this.setState({ text: "" });
            //         // if (this.formRef.current) {
            //         //     this.formRef.current.resetFields();
            //         // }
            //     }
            // }}
            >

                {/* <div style={{ marginTop: 20 }}>
                    <h3>Comentarios:</h3>
                    {[].length > 0 ? (
                        comments.map((comment) => (
                            <Card key={comment.id} title={comment.author && comment.author.name} style={{ marginBottom: 10 }}>
                                <p>{comment.text}</p>
                                <p style={{ justifyContent: "flex-end", display: "flex" }}>
                                    <small>{formatCommentDate(comment.createdAt)}</small>
                                </p>
                            </Card>
                        ))
                    ) : (
                        <p>No hay comentarios disponibles.</p>
                    )}
                </div> */}
            </Drawer>
        );
    }
}

export default BillsDrawer;



// WEBPACK FOOTER //
// ./src/views/Bills/components/BillsDrawer.jsx